import script from "./HowTrainList.vue?vue&type=script&setup=true&lang=js"
export * from "./HowTrainList.vue?vue&type=script&setup=true&lang=js"

import "./HowTrainList.vue?vue&type=style&index=0&id=18fecb7a&lang=scss"

const __exports__ = script;

export default __exports__